<template>
  <article class="pain">
    <div class="pain-block">
      <div class="title">{{ title }}</div>
      <div class="pain-list">
        <div class="list" v-for="(item, index) in list" :key="index">
          <div class="pain-icon"><img :src="item.icon" alt="icon" /></div>
          <div class="pain-title">{{ item.title }}</div>
          <div class="pain-txt">{{ item.txt }}</div>
        </div>
      </div>
    </div>
  </article>
</template>

<script>
export default {
  props: {
    title: String,
    list: Array,
  },
}
</script>

<style lang="less" scoped>
.pain {
  width: 100%;
  background: #f7f7f7;
  padding: 80px 0;
  &-block {
    width: 1180px;
    margin: 0 auto;
  }
  .title {
    font-size: 28px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
    line-height: 40px;
    text-align: center;
  }
  &-list {
    margin-top: 50px;
    display: flex;
    justify-content: space-between;
  }
  .list {
    width: 280px;
    height: 216px;
    padding: 20px 24px;
  }
  &-icon {
    width: 64px;
  }
  &-title {
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 24px;
    margin-top: 20px;
  }
  &-txt {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    line-height: 20px;
    margin-top: 8px;
  }
}
</style>
